import React from 'react';
import { SvgIcon } from '@mui/material';
import { ReactComponent as Icon } from '#static/media/qrcode-icon.svg';

/**
 * Renders qrcode icon.
 * @returns {React.FC}
 */
const QRCodeIcon = (props, ref) => (
  <SvgIcon
    ref={ref}
    component={Icon}
    {...props}
  />
);

export default React.forwardRef(QRCodeIcon);
